import { useEffect } from 'react';

const defaultOptions = {
  threshold: 0.15,
  rootMargin: '0px 0px -50px 0px',
};

const useReveal = (selector = '.fade-in', options = defaultOptions) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return undefined;
    }

    const elements = document.querySelectorAll(selector);
    if (!elements.length) {
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, options);

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [selector, options]);
};

export default useReveal;
